<mat-form-field class="d-flex" [class.clickable]="!disabled" [floatLabel]="lieuParam.floatLabel"
                (click)="!disabled && showPopupChoixLieu($event); $event.stopPropagation();">
    <input type="text" class="clickable" readonly matInput #input="matInput" [required]="required"
           [matTooltip]="lieu?.adresse"
           [matTooltipShowDelay]="500"
           ngModel="{{ lieu?.adresse }}"
           placeholder="{{ placeholder }}" />
    <mat-icon *ngIf="!disabled && !!onClear" class="align-middle ms-1 material-icons-outlined" (click)="clear($event)" matSuffix>backspace</mat-icon>
    <mat-icon *ngIf="!disabled" class="align-middle ms-1" matSuffix>search</mat-icon>
    <mat-icon *ngIf="isShowTypeLieuTooltip && typeLieuTooltip" class="align-middle ms-1 material-icons-outlined" matSuffix
              [matTooltip]="typeLieuTooltip" (click)="$event.stopPropagation()">info</mat-icon>
</mat-form-field>